import axios from 'axios';

export const CompanyUserApi = {
    list: () => axios.get('/web/company-users/'),
    update: (userId, userData) => axios.put(`/web/company-users/${userId}/`, userData),
    create: (userData) => axios.post(`/web/company-users/`, userData),
    remove: (userId) => axios.delete(`/web/company-users/${userId}/`)
};
